import script from "./FormButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormButton.vue?vue&type=script&lang=ts&setup=true"

import "./FormButton.vue?vue&type=style&index=0&id=e9b75c94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9b75c94"]])

export default __exports__